import React, { useState } from 'react';
import { BookOpen, Phone, Mail, MapPin, Plus } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { AgencyAvatar, EmptyState } from './shared';
import { InviteDialog } from './PartnerDialogs';

const STATUS = { active: ['Partenaire', 'bg-emerald-100 text-emerald-700'], pending: ['Invitation en cours', 'bg-amber-100 text-amber-700'] };

export const DirectoryTab = ({ isAdmin, directory, reload }) => {
  const [q, setQ] = useState('');
  const [inviteId, setInviteId] = useState(null);
  const list = directory.filter((a) => `${a.name} ${a.city}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="space-y-4">
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher une agence ou une ville…"
        className="w-full sm:w-80 rounded-xl border border-gray-200 px-3 py-2 text-sm bg-white focus:ring-2 focus:ring-[#B85C38] outline-none" data-testid="directory-search-input" />
      {list.length === 0 ? <EmptyState icon={BookOpen} text="Aucune autre agence sur la plateforme." testid="directory-empty" /> : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {list.map((a) => {
            const st = STATUS[a.partnership_status];
            return (
              <div key={a.id} className="bg-white rounded-2xl border border-[#B85C38]/15 p-5 shadow-sm space-y-3" data-testid={`directory-card-${a.id}`}>
                <div className="flex items-center gap-3">
                  <AgencyAvatar agency={a} />
                  <div className="min-w-0">
                    <p className="font-display font-bold text-[#2B3A2C] truncate">{a.name}</p>
                    {st && <Badge className={st[1]}>{st[0]}</Badge>}
                  </div>
                </div>
                <div className="text-xs text-gray-600 space-y-1">
                  {(a.address || a.city) && <p className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5 text-[#B85C38]" />{[a.address, a.city].filter(Boolean).join(', ')}</p>}
                  {a.phone && <p className="flex items-center gap-1.5"><Phone className="w-3.5 h-3.5 text-[#B85C38]" />{a.phone}</p>}
                  {a.email && <p className="flex items-center gap-1.5"><Mail className="w-3.5 h-3.5 text-[#B85C38]" />{a.email}</p>}
                </div>
                {isAdmin && !a.partnership_status && (
                  <Button size="sm" onClick={() => setInviteId(a.id)} className="w-full bg-[#B85C38] hover:bg-[#a04d2f] text-white rounded-xl" data-testid={`directory-invite-${a.id}`}>
                    <Plus className="w-4 h-4 mr-1" /> Proposer un partenariat
                  </Button>
                )}
              </div>
            );
          })}
        </div>
      )}
      <InviteDialog open={!!inviteId} presetAgencyId={inviteId || ''} onClose={() => setInviteId(null)} directory={directory} onDone={reload} />
    </div>
  );
};
